import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { Card, Button } from '@/components/ui';

const SettingsPage: React.FC = () => {
  const { mode } = useSelector((state: RootState) => state.theme);

  return (
    <div className={mode === 'dark' ? 'text-gray-100' : 'text-gray-900'}>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Settings</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Work in progress</p>
      </div>

      <Card className="p-6">
        <div className="space-y-3">
          <p className="text-base">We're building out settings right now.</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">This page is a placeholder and will be updated soon.</p>
          <div className="pt-2">
            <Button disabled variant="solid">
              Coming soon
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SettingsPage;